import api from '@/lib/api'

const state = () => ({
  allRewards: {
    item_count: 0,
    data: [],
  },

  catalog: {
    catalog_disclaimer: '',
    choices: [],
  },

  currentBrand: {
    brand_key: '',
    brand_name: '',
    disclaimer: '',
  },

  currentReward: {
    credential_list: [],
    redemption_instructions: '',
    reward_name: '',
    is_used: false,
  },

  wallet: [],
})

const getters = {
  allRewards: state => state.allRewards,
  catalog: state => state.catalog,
  currentBrand: state => state.currentBrand,
  currentReward: state => state.currentReward,
  wallet: state => state.wallet,  
}

const actions = { 
  async loadAllRewards ({ commit }, { limit, offset }) {
    const method = '/rewards'

    let params = new URLSearchParams()

    if (limit != null) params.append( 'limit', limit )
    if (offset != null) params.append( 'offset', offset )

    const result = await api.get(method + (params == '' ? params : '?' + params))
    if (result.ok) {
      const { me, rewards } = await result.json()
      commit('SET_ALL_REWARDS', rewards)
      commit('auth/SET_ME', me, { root: true })
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadCatalog ({ commit }) {
    const method = '/rewards/brands'

    const result = await api.get(method)
    if (result.ok) {
      commit('SET_CATALOG', await result.json())
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadCurrentBrand ({ commit }, brand_key) {
    const method = `/rewards/brands/${ brand_key }`

    const result = await api.get(method)
    if (result.ok) {
      commit('SET_CURRENT_BRAND', await result.json())
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadCurrentReward ({ commit }, redemption_id) {
    const method = `/rewards/redemptions/${ redemption_id }`
    
    const result = await api.get(method)
    if (result.ok) {
      commit('SET_CURRENT_REWARD', await result.json())
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadWallet ({ commit }) {

    const result = await api.get('/rewards/redemptions')
    if (result.ok) {
      commit('SET_WALLET', await result.json())
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async redeem ({ }, { brand_key, utid, face_value_cents }) {
    const redemption = { brand_key, utid, face_value_cents }

    const result = await api.post('/rewards/redemptions', { redemption })
    if (result.ok) {
      return { ok: true, inserted: await result.json() }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async updateReward ({ commit }, { redemption_id, ...redemption }) {

    const result = await api.put(`/rewards/redemptions/${ redemption_id }`, { redemption })
    if (result.ok) {
      const updated = await result.json

      commit('UPDATE_CURRENT_REWARD', updated)

      return { ok: true, updated }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

}

const mutations = { 
  SET_ALL_REWARDS: (state, rewards) => state.allRewards = rewards,
  SET_CATALOG: (state, catalog) => state.catalog = catalog,
  SET_CURRENT_BRAND: (state, brand) => state.currentBrand = brand,
  SET_CURRENT_REWARD: (state, reward) => state.currentReward = reward,
  UPDATE_CURRENT_REWARD: (state, reward) => state.currentReward = { ...state.currentReward, ...reward },
  SET_WALLET: (state, wallet) => state.wallet = wallet,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}